(function () {
    'use strict';

    angular
        .module('sodAppointmentSelector')
        .constant('AppointmentSelectorConstant', {
            APPOINTMENT_SELECTOR_DIALOG_IDENTIFIER: 'document-library',
            STEP: {
                PARTICIPANTS: 1,
                DATE_SELECTOR: 2
            }
        });
})();